import Glide from '@glidejs/glide'

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

const glide = new Glide('.glide-image');

const gallery = new Glide('#galleryLarge',{
  peek: { before: 0,  after: 80 },
  gab: 16,
  gap: 24,
  breakpoints: {
    960: {
      peek: { before: 16,  after: 16 }
    }
  },
});

const news = new Glide('#news',{
  perView: 2,
  peek: { before: 0,  after: -240 },
  gap: 40,
  rewind: false,
  breakpoints: {
    1300: {
      perView: 2,
      peek: { before: 0,  after: -400 }
    },
    1200: {
      perView: 2,
      peek: { before: 0,  after: -390 }
    },
    1100: {
      perView: 2,
      peek: { before: 0,  after: -470 }
    },
    1050: {
      perView: 2,
      peek: { before: 0,  after: -600 }
    }
  },
});

if (document.querySelector('.glide-image') !== null){
  glide.mount();
}

if (document.querySelector('#news') !== null){
  news.mount();

  window.onresize = function(event) {
    if (window.matchMedia("(max-width: 60em)").matches) {
      news.destroy();
    }else{
      news.mount();
    }
  };
}

if (document.querySelector('#galleryLarge') !== null){
  gallery.mount()
}

document.querySelectorAll('.js-jump').forEach(function (div, index) {
  div.addEventListener('click', function (event) {
    gallery.go('=' + index)
  });
});

gallery.on(['mount.after', 'run'], function () {
  document.querySelectorAll('.gallery__thumbnails__item').forEach(function (div, index) {
    div.classList.remove('gallery__thumbnails__item--active');

    if (index === gallery.index) {
      div.classList.add('gallery__thumbnails__item--active')
    }
  })
});
